import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { FaEye } from 'react-icons/fa';
import { viewImage } from '../../CommonUtils/viewImage';
import { useNavigate } from 'react-router-dom';
import { RiArrowGoBackFill } from "react-icons/ri";


export default function FfcaEmployeeDetails_21() {
  const Collegetype = sessionStorage.getItem('loginType'); // "college" or "ffca" or "university"
  const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');

  const univCollegecode = localStorage.getItem("collegeCode");

  const FinalCollege = Collegetype === "ffca" ? userid : univCollegecode;
  let navigate = useNavigate();
  function NavtocdcScreen() {
    navigate(-1);
  }
  const AfflEmpFormik = useFormik({
    initialValues: {
      data: [{
        ffcaStatus: "",
        empId: "",
      }]

    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      let hasValidationError = false;
      for (let index = 0; index < values?.data?.length; index++) {
        const item = values.data[index];
        if (!item.ffcaStatus) {
          hasValidationError = true;

          await Swal.fire({
            text: `Row ${index + 1}: Please fill in Faculty Really Associated with College for employee ID ${item.empId}.`,
            icon: 'error',
            confirmButtonText: 'OK'
          });

          break;
        }

      }

      if (hasValidationError) {
        console.log('Validation failed. Please correct the errors.');
        return;
      }

      Swal.fire({
        text: 'Are you sure you want to submit?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, submit it!',
        cancelButtonText: 'No, cancel!',
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = `${config.url.API_URL}updateFfcaTeachingEmployee`;
          CommonAxiosPost(url, values?.data).then((res) => {
            if (res?.data?.scode === '01') {
              successAlertRefresh(res?.data?.sdesc);
            } else {
              failureAlert(res?.data?.sdesc);
            }
          });
        } else {
          console.log('Submission canceled');
        }
      });
    }

  })


  const [Nonteaching, setNonteaching] = useState([]);
  function GetNonTeachingData() {
    let url = config.url.API_URL + `getNonTeachingDetails` + "/" + FinalCollege;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setNonteaching(res?.data?.nonTeachingData);

      }
      else {
        setNonteaching([]);
      }
    })
  }
  const [empdata, setempdata] = useState([]);
  function GetEmpdata() {
    let url = config.url.API_URL + `getEmpReport` + "/" + FinalCollege;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === '01') {
        setempdata(res?.data?.EmpReport);
        res?.data?.EmpReport?.forEach((data, i) => {
          AfflEmpFormik?.setFieldValue(`data[${i}].ffcaStatus`, data?.ffca_status?.toString() ?? '');
          AfflEmpFormik?.setFieldValue(`data[${i}].empId`, data?.emp_id);

        })

      }
      else {
        setempdata([]);
      }
    })
  }

  useEffect(() => {
    GetNonTeachingData();
    GetEmpdata();
  }, [])
  const [index, setIndex] = React.useState(0);

  return (
    <>
      <CommonFormHeading heading="Staff Details" />
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <FormikProvider value={AfflEmpFormik}>
          <Form onChange={AfflEmpFormik.handleChange} onSubmit={AfflEmpFormik.handleSubmit} className="affl-form" >
            <bie.Row className="px-2 pt-3 mb-3">
              {Collegetype === "university" && (<>
                <div className="button-cend pt-1 mb-3">
                  <button type='button' onClick={NavtocdcScreen} className='btn btn-success btn-sm float-end rounded mb-2'><RiArrowGoBackFill size={20} /></button>
                </div>
              </>)}
              {empdata?.length > 0 && (<>
                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">  Teaching Faculty</h1></div>
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered  table-responsive affl-table">
                    <thead>
                      <tr>
                        <th className='cen'> Sl no</th>
                        <th>Employee ID	</th>
                        <th>Employee Name</th>
                        <th style={{ width: "100px" }}>DOB</th>
                        <th>Gender</th>
                        <th style={{ width: "120px" }}> Aadhaar</th>
                        <th> Employee Type/Designation Type	</th>
                        <th> Designation	Course / Combination</th>
                        <th style={{ width: "120px" }}>Mobile	</th>
                        <th>Qualification Details</th>
                        <th>Experience Details</th>
                        <th>Membership Details</th>
                        {Collegetype === "ffca" && (<>
                          <th> Is that Faculty Really Associated with College</th>
                        </>)}
                      </tr>

                    </thead>
                    <tbody>
                      {empdata?.map((empget, index) => (<>
                        <tr key={index}>
                          <td className='cen'>{index + 1}</td>
                          <td className='text-left'>{empget?.emp_id}</td>
                          <td className='text-left'>{empget?.emp_name}</td>
                          <td className='text-left'> {empget?.dob}</td>
                          <td className='text-left'>{empget?.gender}</td>
                          <td className='text-left'>{empget?.aadhar}</td>
                          <td className='text-left'>{empget?.emp_type_name}</td>
                          <td className='text-left'>{empget?.designation_name}({empget?.course_cat_name})</td>
                          <td className='text-left'>{empget?.emp_mobileno}</td>
                          {/* <td className='text-center'>
                            {empget?.qualification_details ? (() => {
                              const [name, path] = empget.qualification_details?.split(' - ');
                              return (
                                <button
                                  type="button"
                                  className="text-dark text-center"
                                  onClick={() => viewImage(path)}
                                >
                                  {name} <br /><FaEye size={20} />
                                </button>
                              );
                            })() : '-'}
                          </td> */}
                          <td className='text-center'>
                            {empget?.qualification_details ? (() => {
                              const [name, path] = empget.qualification_details?.split(' - ') ?? [];
                              if (!name || !path) return '-';
                              return (
                                <button
                                  type="button"
                                  className="text-dark text-center"
                                  onClick={() => viewImage(path)}
                                >
                                  {name} <br /><FaEye size={20} />
                                </button>
                              );
                            })() : '-'}
                          </td>

                          {/* <td className='text-center'>
                            {empget?.experience_details ? (() => {
                              const [name, path] = empget.experience_details?.split(' - ');
                              return (
                                <button
                                  type="button"
                                  className="text-dark text-center"
                                  onClick={() => viewImage(path)}

                                >
                                  {name} <br /><FaEye size={20} />
                                </button>
                              );
                            })() : '-'}
                          </td>
                          <td className='text-center'>
                            {empget?.membership_details ? (() => {
                              const [name, path] = empget.membership_details?.split(' - ');
                              return (
                                <button
                                  type="button"
                                  className="text-dark"
                                  onClick={() => viewImage(path)}
                                >
                                  {name}<br /> <FaEye size={20} />
                                </button>
                              );
                            })() : '-'}
                          </td> */}


                          <td className='text-center'>
                            {empget?.experience_details ? (() => {
                              const [name, path] = empget.experience_details?.split(' - ') ?? [];
                              if (!name || !path) return '-';
                              return (
                                <button
                                  type="button"
                                  className="text-dark text-center"
                                  onClick={() => viewImage(path)}
                                >
                                  {name} <br /><FaEye size={20} />
                                </button>
                              );
                            })() : '-'}
                          </td>

                          <td className='text-center'>
                            {empget?.membership_details ? (() => {
                              const [name, path] = empget.membership_details?.split(' - ') ?? [];
                              if (!name || !path) return '-';
                              return (
                                <button
                                  type="button"
                                  className="text-dark"
                                  onClick={() => viewImage(path)}
                                >
                                  {name}<br /> <FaEye size={20} />
                                </button>
                              );
                            })() : '-'}
                          </td>

                          {Collegetype === "ffca" && (<>

                            <td style={{ width: "10%" }}>
                              <Field type="hidden" name={`data[${index}].empId`} />
                              <div style={{ position: 'relative' }} >
                                <Field as="select" name={`data[${index}].ffcaStatus`} className="form-control">
                                  <option value=''>--select--</option>
                                  <option value='true'>Yes</option>
                                  <option value='false'>No</option>
                                </Field>

                                <ErrorMessage name={`data${index}.ffcaStatus`} component="div" className="text-error" />
                              </div>
                            </td>
                          </>)}
                        </tr>
                      </>))}
                    </tbody>
                  </table>
                  {Collegetype === "ffca" && (<>
                    <div className="button-cend pt-1 mb-3">
                      <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2'>Submit</button>
                    </div>
                  </>)}
                </div>
              </>)}
              {Nonteaching?.length > 0 ? (<>
                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0"> Non-Teaching Faculty</h1></div>
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered  table-responsive affl-table">
                    <thead>
                      <tr>
                        <th> Sl no</th>
                        <th>Employee ID	</th>
                        <th>Employee Name</th>
                        <th>Section</th>
                        <th>Designation</th>
                      </tr>

                    </thead>
                    <tbody>
                      {Nonteaching?.map((nonteachingdata, index) => (<>
                        <tr key={index}>
                          <td className='cen'>{index + 1}</td>
                          <td className='text-left'>{nonteachingdata?.emp_id}</td>
                          <td className='text-left'>{nonteachingdata?.emp_name}</td>
                          <td className='text-left'>{nonteachingdata?.sec_name}</td>
                          <td className='text-left'>{nonteachingdata?.designation}</td>

                        </tr>
                      </>))}
                    </tbody>
                  </table>
                </div>
              </>) : (<b className='text-error text-center'>No data Found</b>)}


            </bie.Row>
          </Form>
        </FormikProvider>
      </bie.Container>



    </>
  )
}
